import { render, staticRenderFns } from "./Sink.vue?vue&type=template&id=73afe9ac&"
import script from "./Sink.vue?vue&type=script&lang=js&"
export * from "./Sink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports